export default __webpack_public_path__ + "static/media/toComputer.82a6e0e4.png";